<template>
  <div>
    <v-row dense class="mt-1 px-2">
      <v-col
        v-for="pm in paymentMethods"
        :key="pm.id"
        cols="3"
      >
        <v-card
          :color="
            paymentMethod && paymentMethod.id === pm.id
              ? 'grey lighten-1'
              : 'grey lighten-4'
          "
          @click="selectPayment(pm)"
        >
          <v-card-text class="d-flex justify-center">
            <v-img
              :src="require(`@/assets/images/payments_method/${pm.code}.png`)"
              width="60px"
              contain
              height="40px"
            ></v-img>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <CartPaymentsKeyboard v-if="paymentMethod" :key="paymentMethod.id" :paymentMethod="paymentMethod" :order="order" :is_mobile="is_mobile" />
  </div>
</template>
<script>
import CartPaymentsKeyboard from "./CartPaymentsKeyboard";

export default {
  name: "CartPaymentsKeyboardCategory",
  components: { CartPaymentsKeyboard },
  data: () => ({
    paymentMethod: null,
  }),
  props: {
    paymentMethods: {
      type: Array,
      default: null,
    },
    order: Object,
    is_mobile: Boolean,
  },
  methods: {
    selectPayment(payment) {
      this.paymentMethod = payment;
    },
  },
};
</script>
